// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ig-0";
export var fileCarousel = "_ig-2";
export var removeFileButton = "_ig-1";